export default require('../../client/marriage/ReviewRequestPage').default;
